import { DecisionActivity, DecisionEvidence } from "../../models/home";
import { LanguageService } from "../language/language.service";
import { HomeDecisionDetailTechnicalI18nService } from "./home-decision-detail-technical-i18n.service";
import { HomeDecisionI18nCore } from "./home-decision-detail-i18n.service.technical-and-fallbacks";

export class HomeDecisionEvidenceHistoryI18n {
  constructor(
    private readonly lang: LanguageService,
    private readonly technicalI18n: HomeDecisionDetailTechnicalI18nService,
    private readonly core: HomeDecisionI18nCore
  ) {}

  translateEvidenceLabel(evidence: DecisionEvidence): string {
    return this.core.translateDateEvidenceLabel(evidence.label) ??
      this.core.translateByNormalizedKey(evidence.type, "home.decisionDetail.evidenceType.") ??
      this.core.translateEvidenceLabelToken(evidence.label) ?? this.core.translateCopy(evidence.label) ??
      evidence.label ?? evidence.type ?? this.lang.translate("home.decisionDetail.notAvailable");
  }
  translateEvidenceValue(evidence: DecisionEvidence): string {
    if (evidence.value) {
      const list = this.technicalI18n.translateDelimitedTokens(evidence.value, evidence.type ?? evidence.label ?? null);
      if (list) return list;
      if (this.core.normalizeKey(evidence.type) === "role_classification") {
        const role = this.core.translateByNormalizedKey(evidence.value, "home.decisionDetail.role.");
        if (role) return role;
      }
      return this.technicalI18n.translateTechnicalString(evidence.type ?? evidence.label ?? null, evidence.value);
    }
    if (evidence.source) return this.core.translateByNormalizedKey(evidence.source, "home.decisionDetail.source.") ?? evidence.source;
    return this.lang.translate("home.decisionDetail.notAvailable");
  }
  translateMissingInformationReason(reason?: string | null): string | null { return this.core.translateCopy(reason); }
  translateHistoryTitle(activity: DecisionActivity): string {
    return this.core.translateByNormalizedKey(activity.type, "home.decisionDetail.history.type.") ??
      this.core.translateCopy(activity.title) ?? activity.title;
  }
  translateHistoryNarrative(activity: DecisionActivity): string {
    if (!activity.narrative) return this.translateHistoryTitle(activity);
    if (!this.core.shouldTranslateResponses()) return activity.narrative;
    const activityType = this.core.normalizeKey(activity.type);
    const state = this.core.translateState(activity.impact?.newState) ?? activity.impact?.newState ?? "";
    const actor = this.core.resolveActorLabel(activity);
    const templated = activityType
      ? this.core.interpolate(`home.decisionDetail.history.narrative.${activityType}`, { actor, state })
      : null;
    return templated ?? this.core.translateCopy(activity.narrative) ?? activity.narrative;
  }
}
